import styled from 'styled-components'

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(320px, 600px);
  grid-gap: 2rem;
  width: 100%;
`

export { AboutGrid }
